import { Component, OnInit } from '@angular/core';

import { 
  AuthenticationService,
} from '../services';

import { TranslateService } from '../i18n';

@Component({
  templateUrl: './public-layout.component.html',
  styleUrls:   ['./public-layout.component.scss'],
})
export class PublicLayoutComponent implements OnInit {
  language         : { lang: string, url: string };
  user             : string;
  userRole         : any;
  loading          : boolean;

  constructor(
    private authService    : AuthenticationService,
    private translate      : TranslateService,
  ) {  }

  ngOnInit(): void {
    this.loading = true;

    const lang = localStorage.getItem('language') || 'EN';
    const url  = lang === 'ES' ? 'assets/img/flags/Mexico.png' : 'assets/img/flags/USA.png';

    this.setLang(lang, url);
  }

  setLang(lang: string, url: string): void {
    this.language = { lang, url };
    // localStorage.setItem('language', lang);
    // this.translate.use(lang);
    if(localStorage.getItem('language') && localStorage.getItem('language') != lang) {
      localStorage.setItem('language', lang);
      this.translate.use(lang);
      window.location.reload();
    }
  }
}


// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/layouts/public-layout.component.ts